export { default } from './EnergyReportEquipmentTable';
